/* eslint class-methods-use-this: "off" */
import { getOrThrow } from '@deephaven/utils';
import { type EventHandlerResult } from '../EventHandlerResult';
import type Grid from '../Grid';
import GridMouseHandler from '../GridMouseHandler';
import GridUtils, { type GridPoint } from '../GridUtils';

/**
 * Detect when the tree expand/collapse button is clicked
 */
class GridRowTreeMouseHandler extends GridMouseHandler {
  static isInTreeBox(gridPoint: GridPoint, grid: Grid): boolean {
    const { column, row, x, y } = gridPoint;
    const { metrics } = grid;
    if (!metrics) throw new Error('metrics not set');

    const {
      gridX,
      gridY,
      firstColumn,
      allColumnXs,
      allColumnWidths,
      allRowHeights,
      allRowYs,
      visibleRowTreeBoxes,
    } = metrics;

    if (
      column === firstColumn &&
      row != null &&
      visibleRowTreeBoxes.get(row) != null &&
      x > gridX &&
      y > gridY
    ) {
      const columnX = getOrThrow(allColumnXs, column);
      const width = getOrThrow(allColumnWidths, column);
      const rowY = getOrThrow(allRowYs, row);
      const height = getOrThrow(allRowHeights, row);
      if (
        x >= gridX + columnX &&
        x <= gridX + columnX + width &&
        y >= gridY + rowY &&
        y <= gridY + rowY + height
      ) {
        return true;
      }
    }
    return false;
  }

  onDown(gridPoint: GridPoint, grid: Grid): EventHandlerResult {
    return GridRowTreeMouseHandler.isInTreeBox(gridPoint, grid);
  }

  onClick(
    gridPoint: GridPoint,
    grid: Grid,
    event: React.MouseEvent
  ): EventHandlerResult {
    if (GridRowTreeMouseHandler.isInTreeBox(gridPoint, grid)) {
      const { row } = gridPoint;
      if (row !== null) {
        grid.toggleRowExpanded(row, GridUtils.isModifierKeyDown(event));
        return true;
      }
    }
    return false;
  }

  // Consume double-clicks in the tree box so `GridSelectionMouseHandler`
  // doesn't fire a same-row `handleMouseSelectStart('replace')`, which would
  // trigger deselect-on-reclick and wipe the row we just toggled.
  onDoubleClick(gridPoint: GridPoint, grid: Grid): EventHandlerResult {
    return GridRowTreeMouseHandler.isInTreeBox(gridPoint, grid);
  }
}

export default GridRowTreeMouseHandler;
